const generateResourceTextNarrative = (resource) => {
    if (resource.text?.div && resource.text.status !== "empty") {
        return resource.text;
    }
    return null;
};

export default generateResourceTextNarrative;